/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Cancel_SuccessInputs */



/**
* | output |
* | --- |
* | "In-progress sync cancelled." |
*
* @param {Snapshot_History_Cancel_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_cancel_success = /** @type {((inputs?: Snapshot_History_Cancel_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Cancel_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "de") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "es") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
	return /** @type {LocalizedString} */ ("In-progress sync cancelled.")
});